<template>
    <nav class="edit-show-nav">
        <ul class="nav-items">
            <li
                v-for="(item, key) in visibleItems"
                :key="key"
                class="nav-item"
            >
                <router-link
                    :to="item.route"
                    :class="['nav-link', {
                        'is-invalid': ! item.valid,
                        'disabled': item.disabled,
                        'active': item.hasChildren && isActiveParent(item.route)
                    }]"
                    :event="!item.disabled ? 'click' : ''"
                    exact-active-class="active"
                >
                    <i
                        class="nav-link-icon"
                        :class="{
                            [`far fa-${item.icon}`]: item.valid,
                            'fas fa-exclamation-circle': ! item.valid,
                        }"
                    />
                    {{ item.label }}
                </router-link>
            </li>
        </ul>
    </nav>
</template>
<script>
import { filter } from 'lodash';
import { mapState } from 'vuex';

export default {
    props: {
        show: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        ...mapState({
            user: state => state.user || {},
        }),

        /**
         * Returns list of available menu items.
         *
         * @returns {object} Menu items.
         */
        items() {
            return {
                episodes: {
                    visible: this.show.hosted,
                    valid: this.show.isValid,
                    disabled: this.show.isFrozen,
                    route: `/shows/${this.$route.params.hash}/episodes`,
                    icon: 'volume-up',
                    label: 'Episodes',
                    hasChildren: false,
                },
                players: {
                    visible: true,
                    valid: true,
                    disabled: this.show.isFrozen,
                    route: `/shows/${this.$route.params.hash}`,
                    icon: 'play-circle',
                    label: 'Players',
                    hasChildren: false,
                },
                analytics: {
                    visible: true,
                    valid: true,
                    disabled: this.show.isFrozen,
                    route: `/shows/${this.$route.params.hash}/analytics`,
                    icon: 'analytics',
                    label: 'Analytics',
                    hasChildren: false,
                },
                settings: {
                    visible: true,
                    valid: this.show.isValid,
                    disabled: this.show.isFrozen,
                    route: `/shows/${this.$route.params.hash}/settings`,
                    icon: 'cog',
                    label: 'Settings',
                    hasChildren: true,
                },
            };
        },

        /**
         * Returns items that should be rendered.
         *
         * @returns {object[]} Menu items to render.
         */
        visibleItems() {
            return filter(this.items, 'visible');
        },
    },

    methods: {
        /**
         * Checks if given path is a parent of current path.
         *
         * @param  {string}  path Parent path to check.
         * @returns {boolean}      True, if current path is a child of a path given as param.
         */
        isActiveParent(path) {
            return this.$route.path.startsWith(path);
        },
    },
};
</script>
